import { Breakpoints, Container, DecorativeImage, DesignTokenSizeEnum, Layout, Text, TextAlignment, TextTag, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background: var(--c-red);
	background: linear-gradient(0deg, rgb(214, 0, 16) 0%, var(--c-red) 26%, var(--c-red) 50%, var(--c-black) 50%, var(--c-black) 100%);
	padding: var(--size-${DesignTokenSizeEnum.dynamic0300}) 0;
	gap: var(--size-${DesignTokenSizeEnum.dynamic0040});
	& img {
		width: 100%;
		max-width: 960px;
	}
	& p {
		color: var(--c-black) !important;
	}
`;

export function FooterSection() {
	return(
		<React.Fragment>
			<FooterContainer>
				<Layout appearance={{
					[Breakpoints.default]: [
						{ name: '.', columns: 1 },
						{ name: 'footer', columns: 22 },
						{ name: '.', columns: 1 }
					],
				}}
				>
						<DecorativeImage src='https://assets.volkswagen.com/is/image/volkswagenag/gti_carback?Zml0PWNyb3AlMkMxJndpZD0yMDQ4JmhlaT0xMjQ4JmZtdD1wbmctYWxwaGEmYmZjPW9mZiY3YWY3' />
						<Container wrap={'always'}>
							<Text
								tag={TextTag.p} textAlign={ TextAlignment.center } appearance={ TokenTextAppearance.headline400 }
							>
								Ahora en
							</Text>
							<Text
								tag={TextTag.p} textAlign={ TextAlignment.center } appearance={ TokenTextAppearance.headline400 } bold
							>
								Negro Carbón
							</Text>
						</Container>
				</Layout>
			</FooterContainer>
		</React.Fragment>
	);
}
